var React = require('react');

function Pencil2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.437 3.3703L16.5054 7.43872L6.20706 17.7371L2.14091 13.6687L12.437 3.3703ZM19.5926 2.3891L17.7782 0.574722C17.077 -0.12647 15.9384 -0.12647 15.2349 0.574722L13.4969 2.31271L17.5653 6.38116L19.5926 4.35389C20.1364 3.81001 20.1364 2.93294 19.5926 2.3891ZM0.0118098 19.3872C-0.0622308 19.7204 0.238621 20.019 0.571879 19.9379L5.10549 18.8387L1.03934 14.7703L0.0118098 19.3872Z","fill":"#04B3C0"}));
}

Pencil2.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Pencil2;

Pencil2.default = Pencil2;
